import type { App } from 'vue';
import { apiPlugin } from '@/core/plugins/api/api';
import { authPlugin } from '@/core/plugins/auth';
import { eventBusPlugin } from '@/core/plugins/event-bus';
import { routerPlugin } from '@/core/plugins/router';
import { virtualScrollerPlugin } from '@/core/plugins/virtual-scroller';
import { vuetifyPlugin } from '@/core/plugins/vuetify';

const plugins = [vuetifyPlugin, eventBusPlugin, authPlugin, apiPlugin, virtualScrollerPlugin, routerPlugin];

export function initPlugins(app: App) {
  plugins.forEach((plugin) => {
    plugin(app);
  });
}
